import request from '@/utils/requestVr'
// 查询分配存储列表分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/enterprise/temp/page',
        method: 'get',
        params: query,
    })
}

export function getDetail(query) {
    return request({
        url: '/vr/storage/enterprise/temp/detail',
        method: 'get',
        params: query,
    })
}

// 查询分配存储详细
export function getObj(id) {
    return request({
        url: '/vr/storage/enterprise/temp/detail?id=' + id,
        method: 'get',
    })
}
// 新增分配存储
export function addObj(data) {
    return request({
        url: '/vr/storage/enterprise/temp/add',
        method: 'post',
        data: data,
    })
}
// 修改分配存储
export function putObj(data) {
    return request({
        url: '/vr/storage/enterprise/temp/edit',
        method: 'post',
        data: data,
    })
}
// 删除分配存储
export function delObj(data) {
    return request({
        url: '/fix/dev/delete',
        method: 'post',
        data: data,
    })
}
